import Vue from 'vue'
import Axios from 'axios'
import {getToken} from '@/common/jwt.service'
import {getAdminId} from '@/common/jwt.service'
import {BASE_PATH, STAR_SHOP_BASE_URL} from '@/common/config'
import axios from "axios";

const convertToFormData = (params) => {
    let form_data = new FormData()
    // form_data.set(params)
    for (var key in params) {
        form_data.append(key, params[key]);
    }

    return form_data
}

const convertToFormDataKeepArray = (params) => {
    let form_data = new FormData();
    form_data = convertToFormDataKeepArrayHelper(params, form_data);

    return form_data;
}

const convertToFormDataKeepArrayHelper = (params, form_data) => {
    for (let key in params) {

        if (Array.isArray(params[key])) {
            for (let i = 0; i < params[key].length; ++i) {
                if (Array.isArray(params[key][i])) {
                    for (let j = 0; j < params[key][i].length; ++j) {
                        if (Array.isArray(params[key][i][j])) {
                            for (let e = 0; j < params[key][i][j].length; ++e) {
                                if (Array.isArray(params[key][i][j][e])) {
                                    for (let p = 0; j < params[key][i][j][e].length; ++p) {
                                        if (Array.isArray(params[key][i][j][e][p])) {
                                            for (let c = 0; j < params[key][i][j][e][p].length; ++c) {
                                                form_data.append(key + '[' + i + '][' + j + '][' + e + '][' + p + '][]', params[key][i][j][e][p][c])
                                            }
                                        } else {
                                            form_data.append(key + '[' + i + '][' + j + '][' + e + '][]', params[key][i][j][e][p])
                                        }
                                    }
                                } else {
                                    form_data.append(key + '[' + i + '][' + j + '][]', params[key][i][j][e]);
                                }

                            }
                        } else {
                            form_data.append(key + '[' + i + '][]', params[key][i][j]);
                        }
                    }
                } else {
                    form_data.append(key + '[]', params[key][i]);
                }
            }
        } else {
            form_data.append(key, params[key]);
        }
    }

    return form_data;
}
const convertToPosFormData = (params) => {
    let form_data = new FormData()
    for (var key in params) {
        if (params[key] && params[key].constructor === Array) {
            for (let i = 0; i < params[key].length; i++)
                if (params[key][i]) {
                    form_data.append(key + '[' + i + ']', params[key][i]);
                }
        } else form_data.append(key, params[key]);
    }
    return form_data
}

const convertToFormDataForCollective = (params) => {
    const formData = new FormData()
    const entries = Object.entries(params) // returns array of object property as [key, value]
    // https://medium.com/front-end-weekly/3-things-you-didnt-know-about-the-foreach-loop-in-js-ff02cec465b1

    for (let i = 0; i < entries.length; i++) {
        // don't try to be smart by replacing it with entries.each, it has drawbacks
        const arKey = entries[i][0]
        let arVal = entries[i][1]
        if (typeof arVal === 'boolean') {
            arVal = arVal === true ? 1 : 0
        }
        if (Array.isArray(arVal)) {
            // console.log('displaying arKey')
            // console.log(arKey)
            // console.log('displaying arval')
            // console.log(arVal)

            if (arVal[0].isFile) {
                for (let z = 0; z < arVal.length; z++) {
                    formData.append(`${arKey}[]`, arVal[z])
                }

                continue // we don't need to append current element now, as its elements already appended
            } else if (arVal[0] instanceof Object) {
                for (let j = 0; j < arVal.length; j++) {
                    if (arVal[j] instanceof Object) {
                        // if first element is not file, we know its not files array
                        for (const prop in arVal[j]) {
                            if (Object.prototype.hasOwnProperty.call(arVal[j], prop)) {
                                // do stuff
                                if (!isNaN(Date.parse(arVal[j][prop]))) {
                                    // console.log('Valid Date \n')
                                    // (new Date(fromDate)).toUTCString()
                                    formData.append(
                                        `${arKey}[${j}][${prop}]`,
                                        new Date(arVal[j][prop])
                                    )
                                } else {
                                    formData.append(`${arKey}[${j}][${prop}]`, arVal[j][prop])
                                }
                            }
                        }
                    }
                }
                continue // we don't need to append current element now, as its elements already appended
            } else {
                arVal = JSON.stringify(arVal)
            }
        }

        if (arVal === null) {
            continue
        }
        formData.append(arKey, arVal)
    }
    return formData
}

export const ApiServiceInit = () => {
    Vue.prototype.$axios = Axios
    Vue.prototype.$axios.defaults.baseURL = BASE_PATH
    Vue.prototype.$axios.defaults.timeout = 120000
    if (getAdminId()) {
        Vue.prototype.$axios.defaults.headers.common['admin-id'] = getAdminId()
    }
    if (getToken()) {
        Vue.prototype.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + getToken()
    }
}

export const StarShopApiServiceInit = () => {
    const star_axios = Axios.create({
        baseURL: STAR_SHOP_BASE_URL,
        timeout: 120000
    })

    if (getAdminId()) {
        star_axios.defaults.headers.common['admin-id'] = getAdminId()
    }
    if (getToken()) {
        star_axios.defaults.headers.common['Authorization'] = 'Bearer ' + getToken()
    }

    Vue.prototype.$starShopAxios = star_axios
}

export const ApiUrl = {
    path(uri) {
        return BASE_PATH + '/' + uri
    },
    starshopPath(uri) {
        return STAR_SHOP_BASE_URL + '/' + uri
    }
}

export const StarShopApiUrl = {
    path(uri) {
        return STAR_SHOP_BASE_URL + '/' + uri
    }
}

export const ApiService = {
    query(resource, params, headers = {}) {
        return Vue.prototype.$axios.get(resource, {
            params: params
        }, headers)
    },

    get(resource, hashid, headers = {}) {
        return Vue.prototype.$axios.get(`${resource}/${hashid}`, {}, headers).catch(error => {
            throw new Error(`ApiService ${error}`)
        })
    },

    post(resource, params, headers = {}) {
        return Vue.prototype.$axios.post(`${resource}`, params, headers)
    },

    update(resource, hashid, params, headers = {}) {
        return Vue.prototype.$axios.post(`${resource}/${hashid}`, params, headers)
    },

    put(resource, params, headers = {}) {
        return Vue.prototype.$axios.post(`${resource}`, params, headers)
    },

    delete(resource, hashid) {
        return Vue.prototype.$axios.delete(`${resource}/${hashid}`)
    },
    custom(method, resource, data = {}) {
        return Vue.prototype.$axios[method](resource, data)
    }
}

export const StarShopApiService = {
    query(resource, params, headers = {}) {
        return Vue.prototype.$starShopAxios.get(resource, {
            params: params
        }, headers).catch(error => {
            throw new Error(`StarShopApiService ${error}`)
        })
    },

    get(resource, hashid, headers = {}) {
        return Vue.prototype.$starShopAxios.get(`${resource}/${hashid}`, {}, headers).catch(error => {
            throw new Error(`StarShopApiService ${error}`)
        })
    },

    post(resource, params, headers = {}) {
        return Vue.prototype.$starShopAxios.post(`${resource}`, params, headers)
    },

    update(resource, hashid, params, headers = {}) {
        return Vue.prototype.$starShopAxios.post(`${resource}/${hashid}`, params, headers)
    },

    put(resource, params, headers = {}) {
        return Vue.prototype.$starShopAxios.post(`${resource}`, params, headers)
    },

    delete(resource, hashid) {
        return Vue.prototype.$starShopAxios.delete(`${resource}/${hashid}`)
    },
    custom(method, resource, data = {}) {
        return Vue.prototype.$starShopAxios[method](resource, data)
    }
}

export const authService = {
    register(params) {
        return ApiService.post('register', params)
    },
    login(params) {
        console.log(BASE_PATH)
        return ApiService.post('login', params)
    },

    verifyForLogin(params) {
        return ApiService.post('verify-login-code', params)
    },

    adminLoginToUserPanel(params) {
        return ApiService.post('login-to-user-panel', params)
    },
    backToAdminPanel(params) {
        return ApiService.post('back-to-admin-panel', params)
    },
    verify(params) {
        return ApiService.post('verify-login-code', params)
    },
    verifyRegister(params) {
        return ApiService.post('verify-register-code', params)
    },
    sendVerify(params) {
        return ApiService.post('send-login-verify-code', params)
    },
    sendVerifyRegister(params) {
        return ApiService.post('send-register-verify-code', params)
    },
    sendVerifyWallet(params) {
        return ApiService.post('wallet/common/change-password/send-code', params)
    },
    sendStarshopVerifyWallet(params) {
        return StarShopApiService.post('wallet/common/change-password/send-code', params)
    },

    sendVerifyForDetermine(params) {
        return ApiService.post(`wallet/ayande/admin/determine-unknown/send-verify-code`, params);
    },
    sendVerifyForDetermineStarshop(params) {
        return StarShopApiService.post(`wallet/ayande/admin/determine-unknown/send-verify-code`, params);
    },

    logout(params) {
        return ApiService.post('logout' , params)
    },
    refreshToken(params) {
        return ApiService.post('refresh-token', params)
    },
    sendForgetPassCode(param) {
        return ApiService.post('forget-password/send-code', param)
    },
    verifyCode(params) {
        return ApiService.post('forget-password/verify-code', params)
    },
    changePass(params) {
        return ApiService.post('forget-password/change-pass', params)
    },
    resendCode(param) {
        return ApiService.post('forget-password/resend-code', param)
    },
    addClickCounter(hashid) {
        return ApiService.get('marketing/add-click-counter', hashid)
    },
    verifyG2faForLogin(params) {
        return ApiService.post('/verify-google-2fa', params)
    },
}

export const userService = {
    getDisabledSecuritySettings() {
        return ApiService.query('admin/users/limited/disabled-security-settings')
    },
    fetchCoreExcelRequests(query) {
        return ApiService.query('user/get-excel-list', query)
    },
    createCoreExcelRequest(params){
        return ApiService.post('user/create-excel-export' , params)
    },
    current() {
        return ApiService.query("user/current")
    },
    update_wallet_sms_by_admin(params) {
        return ApiService.post('notification-sms/admin/update-sms-wallet_manually', params)
    },
    update(params) {
        return ApiService.post('user/update', params)
    },
    update_legal_user(params) {
        return ApiService.post('user/update-legal-user', params);
    },
    authenticate(params) {
        return ApiService.post('user/authenticate', params, {
            'Content-Type': 'multipart/form-data'
        })
    },
    authenticate_legal_user(params) {
        return ApiService.post('user/authenticate-legal-user', params, {
            'Content-Type': 'multipart/form-data'
        })
    },
    delete(hashid) {
        return ApiService.delete('admin/user', hashid)
    },
    restore(hashid) {
        return ApiService.post(`admin/user/restore/${hashid}`)
    },
    find(hashid) {
        return ApiService.query(`admin/user/find/${hashid}`)
    },
    changeUserSetting(hashid, status, referer_id, referer_percent) {
        return ApiService.post(`admin/user/change-user-setting/${hashid}`, {
            status: status,
            referer_id: referer_id,
            referer_percent: referer_percent
        })
    },
    fetchShebaNumbers(hashid) {
        return ApiService.query(`admin/user/sheba-numbers/${hashid}`)
    },
    adminDeleteIban(hashid, params) {
        return ApiService.post(`admin/sheba-number/${hashid}`, params)
    },

    fetchBankAccounts(hashid) {
        return ApiService.query(`admin/user/bank-accounts/${hashid}`)
    },

    changeUserPhoneNumber(params) {
        return ApiService.post('user/change-user-phone', params)
    },
    verificationPhoneNumber(params) {
        return ApiService.post('user/verify-phone', params)
    },
    updateUser(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.post(`admin/user/update-user/${hashid}`, form_data)
    },
    update_legal_user_by_admin(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.post(`admin/user/update-legal-user/${hashid}`, form_data);
    },
    changeAccess(hashid, params) {
        return ApiService.post(`/admin/user/change-access/${hashid}`, params)
    },
    changeAccessV2(hashid, params) {
        return ApiService.post(`admin/user/v2/change-access/${hashid}`, params)
    },
    changeNotificationAccess(hashid, params) {
        return ApiService.post(`admin/user/change-notification-access/${hashid}`, params)
    },
    fetchForSelect() {
        return ApiService.query('admin/user/for-select')
    },
    changePassword(params) {
        return ApiService.post('user/change-password', params)
    },

    userSetting(params) {
        return ApiService.post('user/user-setting', params)
    },

    getUserSetting() {
        return ApiService.query('user/user-settings', '')
    },

    changeUserPassword(params, header) {
        Vue.prototype.$axios.defaults.headers.common['admin-id'] = header
        return ApiService.post('admin/user/change-user-password', params)
    },
    fetchReferers(params) {
        return ApiService.query('admin/user/referers', params);
    },
    fetchTransactionStatistics(hashid) {
        return ApiService.query(`admin/user/transaction-statistics/${hashid}`);
    },
    fetchStatementsStatistics(hashid) {
        return  ApiService.query(`user/statements-statistics/${hashid}`);
    },
    fetchActivitiesLogs(params) {
        return ApiService.query(`admin/user/activities-logs/${params.hashid}`, params)
    },
    fetchStarShopActivitiesLogs(params) {
        return StarShopApiService.query(`admin/user/activities-logs/${params.hashid}`, params)
    },
    countData(is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.query('admin/user/count-data')
    },

    countOpenUserTickets(hashid) {
        return ApiService.query('user/count-user-tickets/')
    },

    registerUserByAdmin(params) {
        let form_data = convertToFormData(params)
        return ApiService.post(`admin/register-by-admin`, form_data)
    },

    addCategory(params) {
        return ApiService.post('admin/user/create-category', params)
    },

    fetchCategory(hashid) {
        return ApiService.query(`admin/user/categories/${hashid}`)
    },

    fetchCategoryMembers(hashid) {
        return ApiService.query(`admin/user/categories/${hashid}/members`)
    },

    updateCategory(params, hashid) {
        return ApiService.post(`admin/user/update-category/${hashid}`, params)
    },

    deleteCategory(hashid) {
        return ApiService.delete('admin/user/category', hashid)
    },

    restoreCategory(hashid) {
        return ApiService.post(`admin/user/category/restore/${hashid}`);
    },

    fetchGroup(hashid) {
        return ApiService.query(`admin/user/group/${hashid}`)
    },

    fetchCategoryGroups(hashid) {
        return ApiService.query(`/admin/user/category-groups/${hashid}`)
    },

    addGroup(hashid, params) {
        return ApiService.post(`admin//user/create-group/${hashid}`, params)
    },

    updateGroup(params, hashid) {
        return ApiService.post(`admin/user/update-group/${hashid}`, params)
    },

    deleteGroup(hashid) {
        return ApiService.delete('admin/user/group', hashid)
    },

    restoreGroup(hashid) {
        return ApiService.post(`admin/user/group/restore/${hashid}`);
    },
    ibanInquiry(params) {
        return ApiService.post('/gateway/iban-inquiry', params)
    },
    updateMerchant(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.post(`admin/user/update-merchant/${hashid}`, form_data)
    },
    shahkarInquiry(params) {
        return ApiService.post('admin/user/shahkar-inquiry',params)
    },

    generateAccessToken() {
        return ApiService.post('/user/generate-access-token');
    },
    fetchAccessToken() {
        return ApiService.query('/user/fetch-access-token');
    },
    fetchApplicationTokens(params) {
        return ApiService.query('admin/user/application-tokens', params);
    },
    generateApplicationToken(params) {
        return ApiService.post('admin/user/application-tokens', params);
    },
    revokeApplicationToken(hashid) {
        return ApiService.delete('admin/user/application-tokens', hashid);
    },
    disable(hashid) {
        return ApiService.post(`admin/user/disable/${hashid}`)
    },



    // not defined
    searchBlackList(params) {
        return ApiService.query('admin/blackList/search', params)
    },
    getCustomersClubEvents() {
        return ApiService.query('customers-club/events')
    },
    updateCustomersClubSetting(params) {
        return ApiService.post('customers-club/', params)
    },
    marketplaceScores(params) {
        return ApiService.post('customers-club/marketplace-scores', params)
    },
    getAdminUsers(params) {
        return ApiService.query('admin/user', params)
    },
    searchAdminUsers(params) {
        return ApiService.query('admin/user/search', params)
    },
    changeAdminAccessV2(hashid, params) {
        return ApiService.post(`admin/user/v2/change-access/${hashid}`, params)
    },
    exportUsersExcel() {
        return ApiService.get('admin/user/excel-export')
    },
    getUserCategories() {
        return ApiService.query('admin/user/categories')
    },
        getCategoryGroups(cat_id) {
        return ApiService.query(`admin/user/groups/${cat_id}`)
    },
    getUsersLimited() {
        return ApiService.query('admin/users/limited')
    },
    userInfoInquiry(hashid) {
        return ApiService.query(`admin/user/info-inquiry/${hashid}`)
    },
    getUserAuthenticationSettings() {
        return ApiService.query('admin/user/authentication-settings')
    },
    updateUserAuthenticationSettings(params) {
        return ApiService.post('admin/user/authentication-settings', params)
    }
};

export const shaparakService = {
    fetchShaparak(hashid, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.get('shaparak/shop-requests', hashid)
    },
    resendNewTerminalRequest(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post('shaparak/new-shop', params)
    },
    changeCreatedRequestStatus(params) {
        return ApiService.post('shaparak/change-request-status', params)
    },
    changeStakeholdersRequestStatus(params) {
        return ApiService.post('shaparak/change-stakeholders-request-status', params);
    },
}

export const addressService = {
    fetch() {
        return ApiService.query('address')
    },
    fetchByShopId(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.query('address', params)
    },
    sync(addresses) {
        return ApiService.post('address', addresses)
    },
    delete(hashid) {
        return ApiService.delete(`address/${hashid}`)
    }
}

export const shebaNumberService = {
    createShebaNumber(params) {
        return ApiService.post(`sheba-number`, params)
    },
    updateShebaNumber(params) {
        return ApiService.post(`sheba-number/${params.id}`, {sheba_number: params.number})
    },
    deleteShebaNumber(hashid) {
        return Axios.delete(`sheba-number/${hashid}`)
    },
    fetch() {
        return ApiService.query('sheba-number')
    },
    fetchBankAccount() {
        return ApiService.query('sheba-number/bank-account')
    },
    fetchByShopId(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.query('sheba-number', params)
    },
    fetchList(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.query('sheba-number/list', params)
    },

    fetchAdminShopShebaNumbers() {
        return ApiService.query('admin/sheba-number/list')
    },

    sync(params) {
        return ApiService.post('sheba-number', params)
    },
    delete(hashid) {
        return ApiService.delete(`sheba-number/${hashid}`)
    }
}

export const gatewayService = {
    changeSettlementSettings(hashid, params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/admin/change-settlement-settings/${hashid}`, params)
    },

    rechargeWalletManually(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('gateway/admin/recharge-manually', form_data)
    },

    fetchReportStatisticsStatements(hashid, query) {
        return ApiService.query(`gateway/get-statements-report-statistics/${hashid}`, query)
    },
    fetchReportStatistics(hashid, query) {
        return ApiService.query(`gateway/get-transactions-report-statistics/${hashid}`, query)
    },
    fetchTransactionOnlineReport(hashid, query) {
        return StarShopApiService.query(`collective/get-online-transactions-report/${hashid}`, query)
    },
    fetchTransactionOfflineReport(hashid, query) {
        return StarShopApiService.query(`collective/get-offline-transactions-report/${hashid}`, query)
    },
    getSignKey(hashid) {
        return ApiService.query(`gateway/get-sign/${hashid}`);
    },
    fetch(params,is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.query('gateway', params)
    },
    fetchCore(params) {
        return ApiService.query('gateway', params)
    },
    fetchCoreByAdmin(params) {
        return ApiService.query('gateway/admin/get', params)
    },
    fetchStarshop(params) {
        return StarShopApiService.query('gateway', params)
    },
    fetchStarshopByAdmin(params) {
        return StarShopApiService.query('gateway/admin/get', params)
    },
    get_payment_helper_shops() {
        return ApiService.query('gateway/get-payment-helper-shops');
    },
    find(hashid, is_admin, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        const route = is_admin ? 'gateway/admin' : 'gateway'
        return service.get(route, hashid)
    },
    create(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('gateway', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    updateAdmin(hashid, params, is_starshop = false) {
        let form_data = convertToFormData(params)
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.update('gateway/admin', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    update(hashid, params) {
        let form_data = convertToFormData(params)
        return service.update('gateway', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    delete(hashid) {
        return ApiService.delete(`gateway/${hashid}`)
    },
    changeStatus(hashid, status, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/admin/change-status/${hashid}`, {
            status: status
        })
    },
    showPSPReportForCommonUser(hashid, status) {
        return ApiService.post(`gateway/show-psp-report-for-common-user/${hashid}`, {
            status: status
        })
    },
    createTerminal(hashid, params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/admin/create-terminal/${hashid}`, params);
    },
    changeTerminalStatus(hashid, params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/admin/change-terminal-status/${hashid}`, params);
    },
    changeLimitation(hashid, params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/admin/change-limitation/${hashid}`, params)
    },
    changeWage(hashid, params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/admin/change-wage/${hashid}`, params)
    },
    changeSheba(params) {
        return ApiService.post('gateway/change-sheba', params)
    },
    addPfTypeRelatedMerchant(params) {
        console.error('business related merchant is not legal'); // ask ali why
        // return ApiService.post('gateway/admin/add-business-type-related-merchant', params);
    },
    userChangeShebaRequest(params) {
        return ApiService.post('gateway/user-change-sheba-request', params)
    },
    disableTerminal(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post('gateway/disable-terminal', params)
    },
    enableTerminal(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post('gateway/enable-terminal', params)
    },
    changeAddress(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post('gateway/change-address', params)
    },
    changeinfo(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post('gateway/change-information', params)
    },
    changeCategoryCode(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post('gateway/change-category', params)
    },
    getIp(params) {
        return ApiService.post('gateway/get-ip', params)
    },
    changeGatewayDetails(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post('gateway/admin/change-details', params)
    },
    fetchNamad(hashid) {
        return ApiService.query(`gateway-namad/${hashid}`)
    },
    addCartGatewayFlag() {
        return ApiService.post('gateway/add-cart-gateway')
    },
    fetchTaxData(hashid) {
        return ApiService.query(`gateway/tax/get/${hashid}`)
    },
    resendTaxInquiry(hashid) {
        return ApiService.post('gateway/tax/resend-inquiry', {hashid: hashid})
    },
    resendTaxRequest(hashid) {
        return ApiService.post('gateway/tax/resend-request', {hashid: hashid})
    },
    getTerminalSettlementSettings(hashid, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.get('gateway/terminal/settlement-settings/find', hashid);
    },
    resendRequest(hashid, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/admin/terminal/settlement-settings/resend-request/${hashid}`, { })
    },
    setTerminalSettlementSettings(hashid, params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/admin/terminal/settlement-settings/update/${hashid}`, params);
    },
    getGatewayShebaNumbers(hashid) {
        return ApiService.get('gateway/get-gateway-sheba-numbers', hashid);
    },
    showPspForCommonUser(hashid, status, type, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/show-psp-report-for-common-user/${hashid}`, {
            status: status,
            type: type
        })
    },
    showStatementForCommonUser(hashid, status, type, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post(`gateway/show-statement-report-for-common-user/${hashid}`, {
            status: status,
            type: type
        })
    },
    getGatewayUsers() {
        return ApiService.query('gateway/user-shop-list');
    }
};

export const ticketService = {
    fetch(params) {
        return ApiService.query('ticket', params)
    },
    fetchAsAdmin(params) {
        return ApiService.query('ticket/admin', params)
    },
    find(hashid) {
        return ApiService.get('ticket', hashid)
    },
    create(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('ticket', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    createTicketAsAdmin(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('ticket/admin/create', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    update(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.update('ticket', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    categories() {
        return ApiService.query('ticket/admin/fetch/categories')
    },
    updateTicketCategories(hashid, params) {
        return ApiService.update('ticket/admin/updateCategories', hashid, params)
    },
    submitComment(data) {
        let form_data = convertToFormData(data)
        return ApiService.post('ticket/comment/add', form_data,  {
            "Content-Type": "multipart/form-data",
        })
    },
    delete(hashid) {
        return ApiService.post(`ticket/admin/comment/delete/${hashid}`)
    },
    updateComment(data) {
        let form_data = convertToFormData(data)
        return ApiService.post('ticket/admin/comment/update', form_data, {
            "Content-Type": "multipart/form-data",
        })
    },
    closeTicket(hashid ,params) {
        return ApiService.post(`ticket/admin/update-status/${hashid}`, params)
    },
    fetchSignature() {
        return ApiService.query('ticket/admin/signature')
    },
    updateSignature(params) {
        return ApiService.post('ticket/admin/signature', params)
    },
    createCategory(params) {
        return ApiService.post('ticket/admin/category', params)
    },
    fetchTicketCategories(query) {
        return ApiService.query('ticket/admin/category', query)
    },
    deleteCategory(hashid) {
        return ApiService.delete('ticket/admin/category', hashid)
    },
    editCategory(hashid, params) {
        return ApiService.post(`ticket/admin/category/${hashid}`, params)
    },
    searchUser(full_name) {
        return ApiService.query('ticket/admin/category/user/search', full_name)
    },
    getCategoryUser(hashid) {
        return ApiService.query(`ticket/admin/category/${hashid}/user`)
    },
    addUserToTicketCategory(params, hashid) {
        return ApiService.post(`ticket/admin/category/${hashid}/user`, params)
    },
    deleteCategoryUser(user_hashid, cat_hashid) {
        return ApiService.custom('delete', `ticket/admin/category/${cat_hashid}/user/${user_hashid}`)
    },
    updateTicketCategory(hashid, params) {
        return ApiService.update('ticket/admin/ticket-category', hashid, params)
    },
    assignAdmin(hashid, params) {
        return ApiService.custom('post', `ticket/admin/${hashid}/assign-admin`, params)
    },
    fetchAdminSignatures(params) {
        return ApiService.query('ticket/admin/signature', params);
    },
}

export const FAQService = {
    fetchCategories(params) {
        return ApiService.query('admin/faq/get-categories', params)
    },
    fetchQuestions(hashid) {
        return ApiService.query(`faq/get-questions/${hashid}`)
    },
    findQuestion(hashid) {
        return ApiService.get('faq/find-question', hashid)
    },
    fetchCategory(hashid) {
    },
    createQuestion(params) {
        return ApiService.post('admin/faq/create-question', params)
    },
    updateQuestion(hashid, params) {
        return ApiService.update('admin/faq/update-question', hashid, params)
    },
    deleteQuestion(hashid) {
        return ApiService.post(`admin/faq/delete-question/${hashid}`)
    },
    restoreQuestion(hashid) {
        return ApiService.post(`admin/faq/restore-question/${hashid}`)
    }
}
export const knowledgeManagementService = {
    fetchCategories(params) {
        return ApiService.query('admin/knowledge-management/get-categories', params)
    },
    fetchQuestions(hashid) {
        return ApiService.query(`admin/knowledge-management/get-questions/${hashid}`)
    },
    find(hashid) {
        return ApiService.get('ticket', hashid)
    },
    findQuestion(hashid) {
        return ApiService.get('admin/knowledge-management/find-question', hashid)
    },
    createCategory(params) {
        return ApiService.post('admin/knowledge-management/create-category', params)
    },
    fetchCategory(hashid) {
        return ApiService.get('admin/knowledge-management/find-category', hashid)
    },
    updateCategory(hashid, params) {
        return ApiService.update('admin/knowledge-management/update-category', hashid, params)
    },
    restoreCategory(hashid) {
        return ApiService.post(`admin/knowledge-management/restore-category/${hashid}`,)
    },
    deleteCategory(hashid) {
        return ApiService.post(`admin/knowledge-management/delete-category/${hashid}`)
    },
    createQuestion(params) {
        return ApiService.post('admin/knowledge-management/create-question', params)
    },
    updateQuestion(hashid, params) {
        return ApiService.update('admin/knowledge-management/update-question', hashid, params)
    },
    deleteQuestion(hashid) {
        return ApiService.post(`admin/knowledge-management/delete-question/${hashid}`)
    },
}

export const dashboardService = {
    fetch() {
        return ApiService.query('dashboard')
    },
    increase(data) {
        return ApiService.post('/gateway/web/payment-request', data)
    }
}
export const newsService = {
    create(params) {
        let form_data = convertToFormData(params);

        return ApiService.post("news/admin/create", form_data, {
            "Content-Type": "multipart/form-data",
        });
    },
    update(hashid, params) {
        let form_data = convertToFormData(params);
        return ApiService.update("news/admin", hashid, form_data, {
            "Content-Type": "multipart/form-data",
        });
    },
    deleteNews(hashid) {
        //console.log(hashid);
        return ApiService.post("news/admin/" + hashid + "/news/delete");
    },
    find(hashid) {
        return ApiService.get("news", hashid);
    },
    CountNewsNotvisited() {
        return ApiService.post("news/Client/Count_News_Not_visited");
    },
    getnews() {
        return ApiService.post("news/Client/getNewsForClient");
    },
    findNewsById(newsid) {
        return ApiService.post("news/Client/findNewsById/" + newsid);
    },
};

export const moneyRequestService = {
    find(tracking_code) {
        return StarShopApiService.query(`money-request/find/${tracking_code}`)
    },
    create(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('money-request/store', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    getReceiptData(tracking_code) {
        return ApiService.query(`money-request/receipt/${tracking_code}`)
    },
    remind(hashid) {
        return ApiService.post(`money-request/remind/${hashid}`)
    },
    showItem(hashid) {
        return StarShopApiService.query(`item/${hashid}`)
    },
    adminShowItem(hashid) {
        return StarShopApiService.query(`item/admin/${hashid}`)
    },
    showCustomer(hashid) {
        return ApiService.query(`customer/${hashid}`)
    },
    adminShowCustomer(hashid) {
        return ApiService.query(`customer/admin/${hashid}`)
    },
    changeStatus(hashid, params) {
        return StarShopApiService.post(`admin/money-request/change-status/${hashid}`, params)
    }
}
export const onlineFactorService = {
    showItem(hashid) {
        return StarShopApiService.get('item', hashid);
    },
    adminShowItem(hashid) {
        return StarShopApiService.get('item/admin', hashid);
    },
    showCustomer(hashid) {
        return StarShopApiService.get('customer', hashid);
    },
    adminShowCustomer(hashid) {
        return StarShopApiService.get('customer/admin', hashid);
    },
    showFactor(hashid) {
        return StarShopApiService.get('factor', hashid);
    },
    adminShowFactor(hashid) {
        return StarShopApiService.get('factor/admin', hashid);
    },
    archiveItem(hashid) {
        return StarShopApiService.delete('item', `${hashid}/archive`);
    },
    adminArchiveItem(hashid) {
        return StarShopApiService.delete('item.admin', `${hashid}/archive`);
    },
    unarchiveItem(hashid) {
        return StarShopApiService.custom('patch', `item/${hashid}/unarchive`);
    },
    adminUnarchiveItem(hashid) {
        return StarShopApiService.custom('patch', `item/admin${hashid}/unarchive`);
    },
    deleteItem(hashid) {
        return StarShopApiService.delete('item', `${hashid}/delete`);
    },
    adminDeleteItem(hashid) {
        return StarShopApiService.delete('item/admin', `${hashid}/delete`);
    },
    archiveCustomer(hashid) {
        return StarShopApiService.delete('customer', `${hashid}/archive`);
    },
    adminArchiveCustomer(hashid) {
        return StarShopApiService.delete('customer/admin', `${hashid}/archive`);
    },
    unarchiveCustomer(hashid) {
        return StarShopApiService.custom('patch', `customer/${hashid}/unarchive`);
    },
    adminUnarchiveCustomer(hashid) {
        return StarShopApiService.custom('patch', `customer/admin${hashid}/unarchive`);
    },
    deleteCustomer(hashid) {
        return StarShopApiService.delete('customer', `${hashid}/delete`);
    },
    adminDeleteCustomer(hashid) {
        return StarShopApiService.delete('customer/admin', `${hashid}/delete`);
    },
    deleteFactor(hashid) {
        return StarShopApiService.delete('factor', `${hashid}/delete`);
    },
    adminDeleteFactor(hashid) {
        return StarShopApiService.delete('factor/admin', `${hashid}/delete`);
    },
    archiveFactor(hashid) {
        return StarShopApiService.delete('factor', `${hashid}/archive`);
    },
    adminArchiveFactor(hashid) {
        return StarShopApiService.delete('factor/admin', `${hashid}/archive`);
    },
    unarchiveFactor(hashid) {
        return StarShopApiService.custom('patch', `factor/${hashid}/unarchive`);
    },
    adminUnarchiveFactor(hashid) {
        return StarShopApiService.custom('patch', `factor/admin/${hashid}/unarchive`);
    },
    createItem(params) {
        let form_data = convertToFormData(params);
        return StarShopApiService.post('item', form_data);
    },
    adminCreateItem(params) {
        let form_data = convertToFormData(params);
        return StarShopApiService.post('item/admin', form_data);
    },
    createCustomer(params) {
        let form_data = convertToFormData(params);
        return StarShopApiService.post('customer', form_data);
    },
    adminCreateCustomer(params) {
        let form_data = convertToFormData(params);
        return StarShopApiService.post('customer/admin', form_data);
    },
    remindFactor(hashid) {
        return StarShopApiService.post(`factor/sub/${hashid}/reminder`);
    },
    cancelFactor(hashid) {
        return StarShopApiService.custom('patch', `factor/sub/${hashid}/cancel`);
    },
    paymentFactor(hashid) {
        return StarShopApiService.get('factor/pay', hashid);
    },
    payMoneyFactor(hashid) {
        return StarShopApiService.post(`online-factor/pay/${hashid}`);
    },
    factorStatusActive(hashid) {
        return StarShopApiService.custom('patch', `factor/admin/${hashid}/change-status?status=1`);
    },
    factorStatusDiactive(hashid) {
        return StarShopApiService.custom('patch', `factor/admin/${hashid}/change-status?status=0`);
    },
    updateCustomer(hashid, data) {
        return StarShopApiService.update('customer', hashid, data);
    },
    updateItem(hashid, data) {
        return StarShopApiService.update('item', hashid, data);
    },
    factorCustomerSearch(search) {
        return StarShopApiService.query('customer/search', { q: search });
    },
    factorItemSearch(search) {
        return StarShopApiService.query('item/search', { q: search });
    },
    getDiscount(params) {
        return StarShopApiService.query('/factor/discounts', params)
    },
    createFactor(data) {
        return StarShopApiService.post('factor', data);
    },
    getFactorCustomerFormat(search) {
        return StarShopApiService.query(`/customer/format`, search)
            .catch((error) => {
                throw new Error(`ShopApiService ${error}`);
            });
    },
    deleteCustomerFormat(id) {
        return StarShopApiService.delete(`/customer/format/admin`, id);
    },
    showFormat(hashid) {
        return StarShopApiService.get('/customer/format/admin/find', hashid);
    },
    adminDeleteField(hashid) {
        return StarShopApiService.delete('/customer/format/admin/field', hashid)
    },
    adminCreateField(data) {
        return StarShopApiService.post('/customer/format/admin/field', data)
    },
    adminUpdateField(hashid, data){
        return StarShopApiService.update('/customer/format/admin/field', hashid, data)
    },
    fetchFields() {
        return StarShopApiService.query('/customer/format/field');
    },
    deleteField(hashid) {
        return StarShopApiService.delete(`/customer/format/field`, hashid);
    },
    submitCustomerFormat(form_data) {
        return StarShopApiService.post(`/customer/format`, form_data);
    },
};

export const couponService = {
    fetch() {
        return ApiService.query('store/coupon')
    },
}

export const storeService = {
    fetch() {
        return ApiService.query('store/coupon')
    },
    create(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('store', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    update(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.update('store', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    find(hashid) {
        return ApiService.get('store', hashid)
    },
    publicAccess(slug) {
        return ApiService.get('store-public-access', slug)
    },
    createCoupon(coupon, hashid) {

        let form_data = convertToFormData(coupon);
        //console.log(hashid);
        return ApiService.post('store/' + hashid + '/coupons/create', coupon, {
            'Content-Type': 'multipart/form-data'
        })
    },
    deleteCoupon(hashid) {


        //console.log(hashid);
        return ApiService.post('store/' + hashid + '/coupons/delete', {
            'Content-Type': 'multipart/form-data'
        })
    },
    checkCoupon(coupon) {


        //console.log(coupon);
        return ApiService.post('coupons/check/' + coupon, {
            'Content-Type': 'multipart/form-data'
        })
    },
}

export const productService = {
    fetch() {
        return ApiService.query('product')
    },
    create(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('product', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    update(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.update('product', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    find(hashid) {
        return ApiService.get('product', hashid)
    },
    publicAccess(store, hashid) {
        return ApiService.query('@' + store + '/' + hashid)
    },
    updateTags(tag, hashid) {
        let form_data = convertToFormData(tag)
        return ApiService.post('product/attach/' + hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    detachTags(tag, hashid) {
        return ApiService.post('product/dettach/' + hashid, tag, {
            'Content-Type': 'multipart/form-data'
        })
    },
    createCoupon(coupon, hashid) {
        return ApiService.post('product/discount/create/' + hashid, {
            'Content-Type': 'multipart/form-data'
        })
    }
};

export const bannerService = {
    create(params) {
        return ApiService.post('admin/banner/store', params);
    },
    update(params, hashid) {
        return ApiService.post(`admin/banner/update/${hashid}`, params);
    },
    delete(hashid) {
        return ApiService.delete('admin/banner/delete', hashid);
    },
    show(hashid) {
        return ApiService.get('admin/banner/show', hashid);
    },
    archive(hashid) {
        return ApiService.post(`admin/banner/archive/${hashid}`);
    },
    restore(hashid) {
        return ApiService.post(`admin/banner/restore/${hashid}`);
    }
}

export const walletService = {
    create(params) {
        return ApiService.post('wallet/common/create', params);
    },
    getAllWalletBankAccountNumbers() {
        return ApiService.query('wallet/common/admin/get-all-wallet-bank-account-numbers');
    },
    getStarShopAllWalletBankAccountNumbers() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-bank-account-numbers');
    },
    getAllWalletSaderatBanks() {
        return ApiService.query('wallet/common/admin/get-all-wallet-saderat-banks');
    },
    getStarShopAllWalletSaderatBanks() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-saderat-banks');
    },
    getAllWalletParsianBanks() {
        return ApiService.query('wallet/common/admin/get-all-wallet-parsian-banks');
    },
    getStarShopAllWalletParsianBanks() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-parsian-banks');
    },
    getAllWalletTejaratBanks() {
        return ApiService.query('wallet/common/admin/get-all-wallet-tejarat-banks');
    },
    getStarShopAllWalletTejaratBanks() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-tejarat-banks');
    },
    getAllWalletPasargadBanks() {
        return ApiService.query('wallet/common/admin/get-all-wallet-pasargad-banks');
    },
    getStarShopAllWalletPasargadBanks() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-pasargad-banks');
    },
    getAllWalletAyandeBanks() {
        return ApiService.query('wallet/common/admin/get-all-wallet-ayande-banks');
    },
    getStarShopAllWalletAyandeBanks() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-ayande-banks');
    },
    getAllWalletSamanBanks() {
        return ApiService.query('wallet/common/admin/get-all-wallet-saman-banks');
    },
    getStarShopAllWalletSamanBanks() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-saman-banks');
    },
    getAllWalletMelliBanks() {
        return ApiService.query('wallet/common/admin/get-all-wallet-melli-banks');
    },
    getStarShopAllWalletMelliBanks() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-melli-banks');
    },
    getAllWalletMellatBanks() {
        return ApiService.query('wallet/common/admin/get-all-wallet-mellat-banks');
    },
    getStarShopAllWalletMellatBanks() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-mellat-banks');
    },
    requestMellatStatements(params) {
        return  ApiService.post('wallet/common/admin/request-mellat-statements', params);
    },
    requestStarShopMellatStatements(params) {
        return  StarShopApiService.post('wallet/common/admin/request-mellat-statements', params);
    },
    getAllWalletKeshavarziBanks() {
        return ApiService.query('wallet/common/admin/get-all-wallet-keshavarzi-banks');
    },
    getStarShopAllWalletKeshavarziBanks() {
        return StarShopApiService.query('wallet/common/admin/get-all-wallet-keshavarzi-banks');
    },
    chargeByDirectPayment(params, hashid) {
        return ApiService.post(`wallet/common/charge-by-direct-payment/${hashid}`, params);
    },
    get(params) {
        return ApiService.query('wallet/common', params);
    },
    find(hashid) {
        return ApiService.get('wallet/common/admin/find', hashid);
    },
    findStarShop(hashid) {
        return StarShopApiService.get('wallet/common/admin/find', hashid);
    },
    changeSettingsByAdmin(params, hashid) {
        return ApiService.post(`wallet/common/admin/change-settings/${hashid}`, params);
    },
    changeStarShopSettingsByAdmin(params, hashid) {
        return StarShopApiService.post(`wallet/common/admin/change-settings/${hashid}`, params);
    },
    setGlobalSettings(params) {
        return ApiService.post('wallet/common/admin/set-global-settings', params);
    },
    setStarShopGlobalSettings(params) {
        return StarShopApiService.post('wallet/common/admin/set-global-settings', params);
    },
    getCoreStats(params) {
        return ApiService.query('wallet/common/admin/get-stats', params);
    },
    getStarshopStats(params) {
        return StarShopApiService.query('wallet/common/admin/get-stats', params);
    },
    getCoreStatsByUserHashId(params,user_hashid) {
        return ApiService.query(`wallet/common/admin/get-stats/${user_hashid}`, params);
    },
    getStarshopStatsByUserHashId(params,user_hashid) {
        return StarShopApiService.query(`wallet/common/admin/get-stats/${user_hashid}`, params);
    },
    getGlobalSettings(params) {
        return ApiService.query('wallet/common/admin/get-global-settings', params);
    },
    getStarShopGlobalSettings(params) {
        return StarShopApiService.query('wallet/common/admin/get-global-settings', params);
    },
    setUniversalSettings(params) {
        return ApiService.post('wallet/common/admin/set-universal-settings', params);
    },
    getUniversalSettings() {
        return ApiService.query('wallet/common/admin/get-universal-settings');
    },
    getPin(params) {
        return ApiService.post('wallet/common/get-pin', params);
    },
    cancelSettlement(hashid) {
        return ApiService.post(`wallet/common/cancel-settlement/${hashid}`);
    },
    adminCancelSettlement(hashid) {
        return ApiService.post(`wallet/common/admin/cancel-settlement/${hashid}`);
    },
    chargeByOauthDay(params, hashid) {
        return ApiService.post(`wallet/day/charge-by-oauth/${hashid}`, params);
    },
    transferDay(params, hashid) {
        return ApiService.post(`wallet/day/transfer/${hashid}`, params);
    },
    transferAyande(params, hashid) {
        return ApiService.post(`wallet/ayande/transfer/${hashid}`, params);
    },
    settlementDay(params, hashid) {
        return ApiService.post(`wallet/day/settlement/${hashid}`, params);
    },
    settlementAyande(params, hashid) {
        return ApiService.post(`wallet/ayande/settlement/${hashid}`, params);
    },
    sendVerificationCode(params) {
        return ApiService.post('wallet/common/change-password/send-code/', params);
    },
    resendSettlement(params) {
        return ApiService.post('wallet/ayande/resend-settlement/', params);
    },
    determineAyande(params, hashid) {
        return ApiService.post(`wallet/ayande/admin/determine-unknown/${hashid}`, params);
    },
    determineAyandeStarshop(params, hashid) {
        return StarShopApiService.post(`wallet/ayande/admin/determine-unknown/${hashid}`, params);
    },

    changeUnknownYetStatus(params, hashid) {
        return ApiService.post(`wallet/ayande/admin/change-unknown-status/${hashid}`, params);
    },
    changeStarShopUnknownYetStatus(params, hashid) {
        return StarShopApiService.post(`wallet/ayande/admin/change-unknown-status/${hashid}`, params);
    },
    paySettlementByAdminDay(params) {
        return ApiService.post('wallet/day/admin/pay-settlement', params);
    },
    payCoreSettlementListAyande(params) {
        return ApiService.post('wallet/ayande/admin/pay-settlement-list', params);
    },
    payStarshopSettlementListAyande(params) {
        return StarShopApiService.post('wallet/ayande/admin/pay-settlement-list', params);
    },
    chargeByBill(params, hashid) {
        return ApiService.post(`wallet/common/charge-by-bill/${hashid}`, params);
    },
    getSettlementDetailDay(hashid) {
        return ApiService.get('wallet/day/settlement-detail', hashid);
    },
    getSettlementDetailAyande(hashid) {
        return ApiService.get('wallet/ayande/settlement-detail', hashid);
    },
    getStarShopSettlementDetailAyande(hashid) {
        return StarShopApiService.get('wallet/ayande/settlement-detail', hashid);
    },
    getAdminSettlementDetailAyande(hashid) {
        return ApiService.get('wallet/ayande/admin/settlement-detail', hashid);
    },
    getAdminStarShopSettlementDetailAyande(hashid) {
        return StarShopApiService.get('wallet/ayande/admin/settlement-detail', hashid);
    },
    chargeByOauthAyande(params, hashid) {
        return ApiService.post(`wallet/ayande/charge-by-oauth/${hashid}`, params);
    },
    getUnknownTransactionCounts(params) {
        return ApiService.query('wallet/ayande/admin/get-unknown-transaction-count', params);
    },
    getStarShopUnknownTransactionCounts(params) {
        return StarShopApiService.query('wallet/ayande/admin/get-unknown-transaction-count', params);
    },
    getReportAccess(params) {
        return ApiService.query('wallet/ayande/admin/get-report-access', params);
    },
    getStarShopReportAccess(params) {
        return StarShopApiService.query('wallet/ayande/admin/get-report-access', params);
    },
    getReportData(params) {
        return ApiService.query('wallet/ayande/admin/get-report-data', params);
    },
    getActualBalanceByBankId(params,bankId){
        return ApiService.query(`wallet/ayande/admin/get-actual-balance/${bankId}`, params);
    },
    getStarShopActualBalanceByBankId(params,bankId){
        return StarShopApiService.query(`wallet/ayande/admin/get-actual-balance/${bankId}`, params);
    },
    checkSettlementToken(params) {
        return ApiService.query('wallet/ayande/admin/check-settlement-token', params);
    },
    checkStarShopSettlementToken(params) {
        return StarShopApiService.query('wallet/ayande/admin/check-settlement-token', params);
    },
    getBankStatus(params) {
        return ApiService.query('wallet/ayande/admin/get-bank-status', params);
    },
    getStarShopBankStatus(params) {
        return StarShopApiService.query('wallet/ayande/admin/get-bank-status', params);
    },
    deleteSettlementToken(params) {
        return ApiService.post('wallet/ayande/admin/delete-settlement-token', params);
    },
    deleteStarshopSettlementToken(params) {
        return StarShopApiService.post('wallet/ayande/admin/delete-settlement-token', params);
    },
    changeBankStatus(params) {
        return ApiService.query(`wallet/ayande/admin/change-bank-status/${params}`, []);
    },
    changeStarShopBankStatus(params) {
        return StarShopApiService.query(`wallet/ayande/admin/change-bank-status/${params}`, []);
    },
    changeBankPayaStatus(params) {
        return ApiService.query(`wallet/ayande/admin/change-bank-paya-status/${params}`, []);
    },
    changeStarShopBankPayaStatus(params) {
        return StarShopApiService.query(`wallet/ayande/admin/change-bank-paya-status/${params}`, []);
    },
    getSettlementToken(params) {
        return ApiService.post('wallet/ayande/admin/get-settlement-token', params);
    },
    getStarShopSettlementToken(params) {
        return StarShopApiService.post('wallet/ayande/admin/get-settlement-token', params);
    },
    changePassword(params) {
        return ApiService.post('wallet/common/change-password', params);
    },
    shareholderCreate(params) {
        return ApiService.post('shareholder/create', params);
    },
    shareholderUpdate(params, hashid) {
        return ApiService.post(`shareholder/update/${hashid}`, params);
    },
    shareholderUpdateByAdmin(params, hashid) {
        return ApiService.post(`shareholder/admin/update/${hashid}`, params);
    },
    shareholderDetail(hashid) {
        return ApiService.query(`shareholder/detail/${hashid}`);
    },
    shareholderDetailByAdmin(hashid) {
        return ApiService.query(`shareholder/admin/detail/${hashid}`);
    },
    shareholderList() {
        return ApiService.query('shareholder/list');
    },
    getAutoSettlementSettings(hashid) {
        return ApiService.query(`wallet/common/get-auto-settlement-setting/${hashid}`);
    },
    setAutoSettlementSettings(params, hashid) {
        return ApiService.post(`wallet/common/set-auto-settlement-setting/${hashid}`, params);
    },
    adminGetIvrAndCollective() {
        return ApiService.query('wallet/common/admin/get-all-active-ivr-and-collective-gateways');
    },
    adminGetStarShopIvrAndCollective() {
        return StarShopApiService.query('wallet/common/admin/get-all-active-ivr-and-collective-gateways');
    },
    adminDeleteWallet(hashid) {
        return ApiService.post(`wallet/ayande/admin/delete-wallet/${hashid}`);
    },
    adminDeleteStarShopWallet(hashid) {
        return StarShopApiService.post(`wallet/ayande/admin/delete-wallet/${hashid}`);
    },
    generateNewSignKey(hashid) {
        return ApiService.post(`wallet/common/generate-new-sign-key/${hashid}`);
    },
    getApiKey(hashid) {
        return ApiService.query(`wallet/common/get-api-key/${hashid}`);
    },
    setSettlementSetting(hashid, payload) {
        return ApiService.post(`wallet/settlement-setting/${hashid}`, payload);
    },
    regenerateApiKey(hashid) {
        return ApiService.post(`wallet/common/generate-new-api-key/${hashid}`);
    },
    regenerateInquiryKey(hashid) {
        return ApiService.post(`wallet/common/generate-new-inquiry-key/${hashid}`);
    },
    editWalletData(params, hashid) {
        return ApiService.post(`wallet/common/edit-wallet-data/${hashid}`, params);
    },
    adminGetCoreTransactionsStats(wallet_prefix, params) {
        return ApiService.query(`wallet/common/admin/transactions-stats/${wallet_prefix}`, params);
    },
    adminGetStarshopTransactionsStats(wallet_prefix, params) {
        return StarShopApiService.query(`wallet/common/admin/transactions-stats/${wallet_prefix}`, params);
    },
    adminGetCoreSettlementListStats(wallet_prefix, params) {
        return ApiService.query(`wallet/ayande/admin/settlement-list-stats/${wallet_prefix}`, params);
    },
    adminGetWalletErrors(params) {
        return ApiService.query(`wallet/common/admin/errors`, params);
    },
    adminGetStarshopSettlementListStats(wallet_prefix, params) {
        return StarShopApiService.query(`wallet/ayande/admin/settlement-list-stats/${wallet_prefix}`, params);
    },
    adminCreateAutoSettlementRequest() {
        return ApiService.post('wallet/ayande/admin/create-auto-settlement-requests');
    },
    adminCreateStarShopAutoSettlementRequest() {
        return StarShopApiService.post('wallet/ayande/admin/create-auto-settlement-requests');
    },
    adminRefreshAllBalance() {
        return ApiService.post('wallet/common/admin/refresh-all-balance');
    },
    adminStarShopRefreshAllBalance() {
        return StarShopApiService.post('wallet/common/admin/refresh-all-balance');
    },
    getIbanInfo(params, hashid) {
        return ApiService.post(`wallet/common/get-iban-info/${hashid}`, params);
    },
    chargeByReceipt(hashid, params) {
        return ApiService.post(`wallet/ayande/admin/charge-user-wallet-by-receipt/${hashid}`, params);
    },
    chargeStarShopByReceipt(hashid, params) {
        return StarShopApiService.post(`wallet/ayande/admin/charge-user-wallet-by-receipt/${hashid}`, params);
    },
    getTransactionReceipt(hashid) {
        return ApiService.get(`wallet/ayande/admin/get-transaction-receipt/${hashid}`, []);
    },
    getStarShopTransactionReceipt(hashid) {
        return StarShopApiService.get(`wallet/ayande/admin/get-transaction-receipt/${hashid}`, []);
    },
    updateTransactionReceipt(hashid, params) {
        return ApiService.post(`wallet/ayande/admin/update-transaction-receipt/${hashid}`, params);
    },
    updateStarShopTransactionReceipt(hashid, params) {
        return StarShopApiService.post(`wallet/ayande/admin/update-transaction-receipt/${hashid}`, params);
    },
    getActiveBanks() {
        return ApiService.query('wallet/common/get-active-banks');
    },
    getStarShopActiveBanks() {
        return StarShopApiService.query('wallet/common/get-active-banks');
    },
    transfer(params) {
        return ApiService.post('wallet/common/admin/transfer', params);
    },
    transferStarShop(params) {
        return StarShopApiService.post('wallet/common/admin/transfer', params);
    },
    chargeWalletManually() {
        return ApiService.post('wallet/common/admin/charge-wallet-manually', []);
    },
    accountBanksList() {
        return ApiService.query('wallet/common/admin/get-account-banks-list');
    },
    switchingSettings() {
        return ApiService.query('wallet/common/admin/get-switching-settings');
    },
    updateSwitchingSettings(body) {
        return ApiService.post('wallet/common/admin/set-switching-settings', body);
    },
    chargeStarShopWalletManually() {
        return StarShopApiService.post('wallet/common/admin/charge-wallet-manually', []);
    },
    accountStarShopBanksList() {
        return StarShopApiService.query('wallet/common/admin/get-account-banks-list');
    },
    switchingStarShopSettings() {
        return StarShopApiService.query('wallet/common/admin/get-switching-settings');
    },
    updateStarShopSwitchingSettings(body) {
        return StarShopApiService.post('wallet/common/admin/set-switching-settings', body);
    },
    getAllAccountsOfOneBankForSelect() {
        return ApiService.query('accounting/admin/get-all-accounts-for-select/')
    },
    getStarShopAllAccountsOfOneBankForSelect() {
        return StarShopApiService.query('accounting/admin/get-all-accounts-for-select/')
    },
    createLevelForShareholder(body) {
        return StarShopApiService.post('wallet/common/admin/shareholder-settings/level', body)
    },
    editLevelForShareholder(body, hashid) {
        return StarShopApiService.post(`wallet/common/admin/shareholder-settings/level/${hashid}`, body)
    },
    getLevels() {
        return StarShopApiService.query('shareholder/levels')
    },
    adminGetCoreOpenBankingRequestsStats(params) {
        return ApiService.query(`wallet/common/admin/open-banking-requests-stats`, params);
    },
    adminGetStarshopOpenBankingRequestsStats(params) {
        return StarShopApiService.query(`wallet/common/admin/open-banking-requests-stats`, params);
    },
};

export const stakeholdersService = {
    create(params) {
        return ApiService.post('stakeholders/create', params);
    },
    create_business_type(params) {
        return ApiService.post('stakeholders/admin/create-pf-type', params);
    },
    create_wallet_type(params) {
        return ApiService.post('stakeholders/create-wallet-type', params);
    },
    create_psp_type(params) {
        return ApiService.post('stakeholders/create-psp-type', params);
    },
    createFromUsers(params) {
        return ApiService.post('stakeholders/create-from-users', params);
    },
    find(hashid) {
        return ApiService.get('stakeholders/find', hashid);
    },
    update(params, hashid) {
        return ApiService.post(`stakeholders/update/${hashid}`, params);
    },
    update_business_type(params, hashid) {
        return ApiService.post(`stakeholders/admin/update-pf-type/${hashid}`, params);
    },
    update_wallet_type(params, hashid) {
        return ApiService.post(`stakeholders/update-wallet-type/${hashid}`, params);
    },
    update_psp_type(params, hashid) {
        return ApiService.post(`stakeholders/update-psp-type/${hashid}`, params);
    },
    get_status(hashid) {
        return ApiService.get('stakeholders/get-status', hashid);
    },
    update_status(params, hashid) {
        return ApiService.post(`stakeholders/admin/update-status/${hashid}`, params);
    },
    get_selected_shops(hashid) {
        return ApiService.get('stakeholders/get-selected-shops', hashid);
    },
    get_shop_stakeholders(hashid) {
        return ApiService.get('stakeholders/get-shop-stakeholders', hashid);
    },
    get_dedicated_shop_stakeholders(hashid) {
        return ApiService.get('stakeholders/get-dedicated-shop-stakeholders', hashid);
    },
    get_shop_enabled_stakeholders(hashid) {
        return ApiService.get('stakeholders/get-shop-enabled-stakeholders', hashid);
    },
    get_dedicated_shop_enabled_stakeholders(hashid) {
        return ApiService.get('stakeholders/get-dedicated-shop-enabled-stakeholders', hashid);
    },
    get_all_stakeholders() {
        return ApiService.query('stakeholders/get-all');
    },
    get_all_business_stakeholders(is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.query('stakeholders/admin/get-all-business-type');
    },
    get_all_dedicated_stakeholders() {
        return ApiService.query('stakeholders/get-all-dedicated');
    },
    update_shop_stakeholders(params, hashid) {
        return ApiService.post(`stakeholders/update-shop-stakeholders/${hashid}`, params);
    },
    update_dedicated_shop_stakeholders(params, hashid) {
        return ApiService.post(`stakeholders/update-dedicated-shop-stakeholders/${hashid}`, params);
    },
    delete(hashid) {
        return ApiService.delete(`stakeholders/admin/delete`, hashid);
    }
};

export const pardakhtShakhsiService = {
    fetch() {
        return ApiService.query('admin/pardakht-shakhsi')
    },
    update(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('admin/pardakht-shakhsi', form_data)
    },
    find(hashid) {
        return ApiService.get('factor/admin/find', hashid)
    },
    changeWage(hashid, params) {
        let form_data = params
        return ApiService.post(`factor/admin/update-wage/${hashid}`, form_data)
    },
    getDirectForm(username) {
        return ApiService.get('pardakht-shakhsi/direct', username)
    },
    newDirectPay(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('pardakht-shakhsi/direct', form_data)
    },
    getCheckoutData(tracking_code) {
        return ApiService.get('pardakht-shakhsi/checkout', tracking_code)
    },
    getReceiptData(tracking_code) {
        return ApiService.get('pardakht-shakhsi/receipt', tracking_code)
    },
    getGeneralSettings() {
        return ApiService.query('admin/pardakht-shakhsi/general-settings')
    },
    updateGeneralSettings(params) {
        return ApiService.post('admin/pardakht-shakhsi/general-settings',params)
    },
    changeDedicatedSettings(params) {
        return ApiService.post('admin/pardakht-shakhsi/dedicated-settings',params)
    }
}

export const notificationService = {
    fetch() {
        return ApiService.query('notification')
    },
    update(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('notification', form_data)
    },
    show(hashid) {
        return ApiService.get('notifications/show', hashid);
    },
}

export const telegramNotificationService = {
    fetch() {
        return ApiService.query('notification-telegram/get')
    },
    update(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('notification-telegram/update-setting', form_data)
    }
}
export const notificationSmsService = {
    fetch() {
        return ApiService.query('notification-sms')
    },
    update(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('notification-sms', form_data)
    },
    updatsetSmsPrice(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('notification-sms/admin/set-sms-price', form_data)
    },
    updateSmsWallet(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('notification-sms/update-sms-wallet', form_data)
    },
    getRechargeData(tracking_code) {
        return ApiService.query(`notification-sms/get-recharge-result/${tracking_code}`)
    }
}
export const verifyMailService = {
    verify(tracking_code) {
        return ApiService.get('email-verification', tracking_code)
    }
}

export const pspRequestService = {
    fetch() {
        return ApiService.query('psp-request/admin')
    },
    find(hashid) {
        return ApiService.get('psp-request/admin/find', hashid)
    },
    changeStatus(hashid, status) {
        let form_data = {'status': status}
        return ApiService.post(`psp-request/admin/change-status/${hashid}`, form_data)
    },
    changeUserPass(hashid, form_data) {
        return ApiService.post(`psp-request/admin/change-user-pass/${hashid}`, form_data)
    },
    fetchByShopId(hashid, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.get('psp-request/admin', hashid)
    }
}

export const dashboardPluginService = {
    fetchDashboard() {
        return ApiService.query('dashboard/fetch')
    },
    refreshDashboard() {
        return ApiService.query('dashboard/fetch?update_dashboard=true')
    },
    fetchStarShopDashboard() {
        return StarShopApiService.query('dashboard/fetch')
    },
    refreshStarShopDashboard() {
        return StarShopApiService.query('dashboard/fetch?update_dashboard=true')
    }
}

export const settlementService = {
    changeStatus(hashid, status) {
        return ApiService.post(`settlement/admin/change-status/${hashid}`, {
            status: status
        })
    },
    changeDetailStatus(hashid, status) {
        return ApiService.post(`settlement/admin/change-detail-status/${hashid}`, {
            status: status
        })
    },
    updateSettlement(hashid, params) {
        return ApiService.post(`settlement/admin/update/${hashid}`, params)
    },
    find(hashid) {
        return ApiService.get('settlement/find', hashid)
    },
    fetchFiles() {
        return ApiService.query('settlement/admin/fetch-files')
    },
    createSettlementRequestForStakeholder(params) {
        return ApiService.post('settlement/create-request-for-stakeholder', params);
    },
    createSettlementRequestForWallet(params) {
        return ApiService.post('settlement/create-request-for-wallet', params);
    },
    changeBankingWage(params) {
        return ApiService.post('settlement/admin/set-banking-wage', params);
    },
    findBankingWage() {
        return ApiService.query('settlement/admin/get-banking-wage');
    },
    requestSettlementScript(type) {
        return Axios.get(`settlement/admin/request?type=${type}`);
    },
    fetchAdminPhones(){
        return Axios.get(`settlement/admin/admin-phones`);
    },
    createAdminPhone(payload){
        return Axios.post(`settlement/admin/admin-phone`, payload);
    },
    adminFind(hashid) {
    return ApiService.get('settlement/admin/find', hashid);
    },
    adminFindPspSettlement(hashid) {
        return ApiService.get('settlement/admin/psp-settlements/find', hashid);
    },
    changePspSettlementStatus(hashid, status) {
        return ApiService.post(`settlement/admin/psp-settlements/change-status/${hashid}`, {
            status: status
        })
    },
    fetchPspCutOffs() {
        return ApiService.query('settlement/admin/psp-cut-off');
    },
    updatePspCutOffs(params) {
        return ApiService.post('settlement/admin/psp-cut-off', params);
    }
};

export const paymanService = {
    fetch(params) {
        return ApiService.query('payman', params)
    },
    find(hashid) {
        return ApiService.get('payman/find', hashid)
    },
    create(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('payman', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    update(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.update('payman/update', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    updateByAdmin(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.update('payman/update-by-admin', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    delete(hashid) {
        return ApiService.delete(`payman/${hashid}`)
    },
    changeStatus(hashid, status) {
        return ApiService.post(`payman/change-status/${hashid}`, {
            status: status
        })
    },
    changeWage(hashid, params) {
        return ApiService.post(`payman/change-wage/${hashid}`, params)
    }
}

export const ivrService = {
    fetch(params) {
        return StarShopApiService.query('ivr', params)
    },
    fetchByAdmin(params) {
        return StarShopApiService.query('ivr/admin', params)
    },
    find(hashid) {
        return StarShopApiService.get('ivr/admin/find', hashid)
    },
    create(params) {
        let form_data = convertToFormData(params)
        return StarShopApiService.post('ivr/create', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    update(hashid, params) {
        let form_data = convertToFormData(params)
        return StarShopApiService.update('ivr/update', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    updateByAdmin(hashid, params) {
        let form_data = convertToFormData(params)
        return StarShopApiService.update('ivr/admin/update-by-admin', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    getLimitation(hashid) {
        return StarShopApiService.get('ivr/admin/get-limitation', hashid);
    },
    changeLimitation(hashid, params) {
        return StarShopApiService.post(`ivr/admin/change-limitation/${hashid}`, params)
    },
    delete(hashid) {
        return StarShopApiService.delete(`ivr/admin/delete/${hashid}`)
    },
    changeStatus(hashid, status) {
        return StarShopApiService.post(`ivr/admin/change-status/${hashid}`, {
            status: status
        })
    },
    changeWage(hashid, params) {
        return StarShopApiService.post(`ivr/admin/change-wage/${hashid}`, params)
    },
    billInquiry(hashid) {
        return StarShopApiService.query(`ivr/bill-inquiry/${hashid}`)
    },
    adminBillInquiry(hashid) {
        return StarShopApiService.query(`ivr/admin/bill-inquiry/${hashid}`)
    },
}

export const dedicatedService = {
    fetch(params) {
        return ApiService.query('dedicated', params)
    },
    fetchForSelect() {
        return ApiService.query('dedicated/for-select');
    },
    fetchShopCategories(hashid) {
        return StarShopApiService.query(`dedicated/${hashid}/categories`)
    },
    fetchPspData(hashid) {
        return ApiService.get('dedicated/psp-data', hashid)
    },
    find(hashid) {
        return ApiService.get('dedicated/find', hashid)
    },
    create(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('dedicated/create', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    update(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.update('dedicated/update', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    updateFullForm(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.update('dedicated/update-full-form', hashid, form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    delete(hashid) {
        return ApiService.delete(`dedicated/delete/${hashid}`)
    },
    changeSettings(hashid, params) {
        return ApiService.post(`dedicated/admin/change-settings/${hashid}`, params)
    },
    setPSP(hashid, params) {
        return ApiService.post(`dedicated/set-psp/${hashid}`, params)
    },
    setPSPRequest(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.post(`dedicated/set-psp-request/${hashid}`, form_data)
    },
    getSignKey(hashid) {
        return ApiService.query(`dedicated/get-sign/${hashid}`);
    },
    changeStakeholdersRequestStatus(params) {
        return ApiService.post('dedicated/admin/change-stakeholders-request-status', params);
    },
    fetchCategory(hashid){
        return StarShopApiService.query(`dedicated/admin/categories/${hashid}`)
    },
    fetchCategoriesForSelect(is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.query(`dedicated/admin/categories/for-select`)
    },
    addCategory(params) {
        return StarShopApiService.post('dedicated/admin/categories',params);
    },
    restoreCategory(hashid) {
        return StarShopApiService.post(`dedicated/admin/categories/restore/${hashid}`);
    },
    deleteCategory(hashid) {
        return StarShopApiService.delete('dedicated/admin/categories',hashid);
    },
    updateCategory(params, hashid) {
        return StarShopApiService.post(`dedicated/admin/categories/update-category/${hashid}`, params)
    },
    updateShopCategories(params, hashid){
        return StarShopApiService.post(`dedicated/${hashid}/categories`, params)
    }
}

export const collectiveService = {
    fetch(params) {
        return StarShopApiService.query('collective/admin', params)
    },
    fetchGeneralSettings(params) {
        return StarShopApiService.query('collective/admin/fetch-general-settings', params)
    },
    find(hashid) {
        return StarShopApiService.get('collective/admin/find', hashid)
    },
    findGate(hashid) {
        return StarShopApiService.get('collective/admin/find-gate', hashid)
    },
    findByShopId(params) {
        return StarShopApiService.query('collective/admin/fetch-by-shop-id', params)
    },
    findByShopIdOnPF(params) {
        return ApiService.query('collective/admin/fetch-by-shop-id', params)
    },
    create(params) {
        let form_data = convertToFormData(params)
        return StarShopApiService.post('collective/admin/create', form_data)
    },
    updateSwitchingSetting(hashid, params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        // let form_data = convertToFormData(params)
        return service.update('collective/admin/update-switching-setting', hashid, params)
    },
    updateGate(hashid, params) {
        let form_data = convertToFormData(params)
        return StarShopApiService.update('collective/admin/update-gate', hashid, form_data)
    },
    updateSettings(params) {
        let form_data = convertToFormData(params)
        return StarShopApiService.post('collective/admin/update-settings', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    deleteGateway(hashid) {
        return StarShopApiService.delete('collective/admin/delete-gateway', hashid)
    },
    update_wallet_settings(params) {
        return StarShopApiService.post('collective/update-wallet-settings', params);
    },
    get_wallet_settings(params) {
        return StarShopApiService.query('collective/get-wallet-settings', params);
    },
    getActivePsp() {
        return StarShopApiService.query('gateway/admin/active-psp', '')
    }
};

export const transactionService = {
    fetchCoreStatistics(params) {
        let query = {
            query: params
        }
        return ApiService.query('transaction/statistics', query)
    },
    fetchAdminCoreStatistics(params) {
        let query = {
            query: params
        }
        return ApiService.query('admin/transaction/statistics', query)
    },
    fetchStarshopStatistics(params) {
        let query = {
            query: params
        }
        return StarShopApiService.query('transaction/statistics', query)
    },
    fetchAdminStarshopStatistics(params) {
        let query = {
            query: params
        }
        return StarShopApiService.query('admin/transaction/statistics', query)
    },
    fetchCoreTransactionMonitoring(query){
        return ApiService.query('admin/transaction/monitoring?', query)
    },
    fetchCoreTransaction(query){
        return ApiService.query('transaction?' + query)
    },
    fetchStarshopTransaction(query){
        return StarShopApiService.query('transaction?' + query)
    },
    fetchAdminCoreTransaction(query){
        return ApiService.query('admin/transaction?' + query)
    },
    fetchAdminStarshopTransaction(query){
        return StarShopApiService.query('admin/transaction?' + query)
    },
    fetchCoreExcelRequests(query) {
        return ApiService.query('transaction/excel-request', query)
    },
    fetchStarshopExcelRequests(query) {
        return StarShopApiService.query('transaction/excel-request', query)
    },
    createCoreExcelRequest(params){
        return ApiService.post('transaction/excel-request' , params)
    },
    createStarshopExcelRequest(params){
        return StarShopApiService.post('transaction/excel-request' , params)
    },
    deleteCoreExcelRequest(hashid){
        return ApiService.delete('transaction/excel-request' , hashid)
    },
    deleteStarshopExcelRequest(hashid) {
        return StarShopApiService.delete('transaction/excel-request' , hashid)
    },
    fetchTransactionNotificationSetting() {
        return ApiService.query('transaction/notification-setting')
    },
    updateTransactionNotificationSetting(params) {
        return ApiService.post('transaction/notification-setting', params)
    },
    updateCountOfFailedTransaction(params) {
        return ApiService.post('transaction/notification-setting/count-of-failed-transaction', params)
    },
    deletePhoneNumberInTransactionNotification(phone_number) {
        return ApiService.delete('transaction/notification-setting' , phone_number)
    },
    fetchNonSuccessTransactionNotificationSetting() {
        return ApiService.query('transaction/non-success-notification-setting')
    },
    updateNonSuccessTransactionNotificationSetting(params) {
        return ApiService.post('transaction/non-success-notification-setting', params)
    },
    updateCountOfNonSuccessTransaction(params) {
        return ApiService.post('transaction/notification-setting/count-of-non-success-transaction', params)
    },
    deletePhoneNumberInNonSuccessTransactionNotification(phone_number) {
        return ApiService.delete('transaction/non-success-notification-setting', phone_number)
    },
    updateCoreTransactionStatus(hashid){
        return ApiService.post(`transaction/change-status/${hashid}`)
    },
    updateStarshopTransactionStatus(hashid){
        return StarShopApiService.post(`transaction/change-status/${hashid}`)
    },

    requestInquiryTransaction(params) {
        return ApiService.post('admin/transaction/request-inquiry', params)
    },
}
export const transactionRoutingService = {
    fetchCoreSetting() {
        return ApiService.query('transaction-routing/admin')
    },
    fetchStarshopSetting() {
        return StarShopApiService.query('transaction-routing/admin')
    },
    setCoreSetting(params) {
        return ApiService.post('transaction-routing/admin', params)
    },
    setStarshopSetting(params) {
        return StarShopApiService.post('transaction-routing/admin', params)
    },
    fetchCoreStatistics() {
        return ApiService.query('transaction-routing/admin/statistics')
    },
    fetchStarshopStatistics() {
        return StarShopApiService.query('transaction-routing/admin/statistics')
    }
}

export const marketingService = {
    fetchData(query, is_admin) {
        let route = is_admin ? 'marketing/admin' : 'marketing'
        return ApiService.query(route, query)
    },
    searchSubset(full_name, hashid) {
        return ApiService.query(`marketing/admin/subset/${hashid}/find`, {full_name})
    },
    fetchStarshopData(query, is_admin) {
        let route = is_admin ? 'marketing/admin' : 'marketing'
        return StarShopApiService.query(route, query)
    },
    fetchMarketingTools() {
        return ApiService.query('marketing/tools')
    },
    fetchSubsets(params) {
        return ApiService.query('marketing', params)
    },
    fetchMarketerSubsets(hashid) {
        return ApiService.query(`marketing/${hashid}/subsets`)
    },
    fetchStarshopMarketerSubsets(hashid) {
        return StarShopApiService.query(`marketing/${hashid}/subsets`)
    },
    changeMarketingSetting(params) {
        return ApiService.post('marketing/marketing_setting', params)
    },

    changeSpecificMarketerPercentSetting(params) {
        return ApiService.post('marketing/change-specific-marketer-setting', params)
    },

    changeStarshopSpecificMarketerPercentSetting(params) {
        return StarShopApiService.post('marketing/change-specific-marketer-setting', params)
    },
    fetchSetting() {
        return ApiService.query('marketing/marketing_setting')
    },
    uploadBanner(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('marketing/marketing_setting/upload_banner', form_data)
    },
    fetchSpecificMarketerSetting(hashid) {
        let params = {
            hashid: hashid
        }
        return ApiService.query('marketing/specific-marketer-setting', params)
    },
    fetchStarshopSpecificMarketerSetting(hashid) {
        let params = {
            hashid: hashid
        }

        return StarShopApiService.query('marketing/specific-marketer-setting', params)
    },
    fetchSubsetTerminals(hashid) {
        return ApiService.query(`marketing/get-subset-terminals/${hashid}`)
    },
    fetchPSPReportStatistics(params) {
        return ApiService.post('marketing/get-psp-report-statistics/', params)
    },
    fetchAppReportStatistics(hashid) {
        return ApiService.query(`marketing/get-app-report-statistics/${hashid}`)
        return ApiService.query(`marketing/specific-marketer-setting/?hashid=${hashid}`)
    },
    getWages(hashid) {
        return ApiService.query(`marketing/psp-wage-setting/${hashid}`)
    },
    getStarshopWages(hashid) {
        return StarShopApiService.query(`marketing/psp-wage-setting/${hashid}`)
    },
    deleteWage(id) {
        return Axios.delete(`marketing/psp-wage-setting/delete/${id}`)
    },
    deleteStarshopWage(id) {
        return StarShopApiService.delete(`marketing/psp-wage-setting/delete/${id}`)
    },
    updateWage(payload) {
        return Axios.put(`marketing/psp-wage-setting/update/${payload.id}`, payload)
    },
    updateStarshopWage(payload) {
        return StarShopApiService.put(`marketing/psp-wage-setting/update/${payload.id}`, payload)
    },
    createWage(payload) {
        return Axios.post(`marketing/psp-wage-setting/create`, payload)
    },
    createStarshopWage(payload) {
        return StarShopApiService.post(`marketing/psp-wage-setting/create`, payload)
    },
    setShebaNumber(sheba_id) {
        return ApiService.post(`marketing/set-sheba-number`, sheba_id)
    },
    fetchPosStatistics(query){
        return StarShopApiService.query(`marketing/pos-statistics/statistics`, query)
    },
    fetchPosStatisticsList(){
        return StarShopApiService.query(`marketing/pos-statistics`)
    },
    fetchPosVisitor(){
        return StarShopApiService.query(`marketing/pos-visitor`)
    },
    posPublicWage(payload){
        return StarShopApiService.post(`marketing/pos-visitor/set-public-wage`, payload)
    },
    getPosPublicWage(){
        return StarShopApiService.query(`marketing/pos-visitor/public-wage`)
    },
    posSettingUploadExcel(form_data){
        return StarShopApiService.post('marketing/pos-statistics', form_data,  {
            'Content-Type': 'multipart/form-data'
        })
    },
    changeAgent(payload) {
        // refactor
        if(payload.terminal_number === '') {
            return StarShopApiService.put(`marketing/pos-acceptor/${payload.visitor_id}?visitor_id=${payload.agent_id}`)
        }else {
            return StarShopApiService.put(`marketing/pos-acceptor/${payload.visitor_id}?visitor_id=${payload.agent_id}&terminal_number=${payload.terminal_number}`)
        }
    },
    fetchUserRefererList(hashid){
        return ApiService.query(`marketing/admin/user-referer-list/${hashid}`)
    },
    adminUpdateUserReferList(params){
        return ApiService.post('marketing/admin/user-referer-list', params)
    },
}
export const customersClubService = {
    set(params) {
        let form_data = convertToFormData(params)
        return ApiService.post('customers-club', form_data)
    },
    fetch() {
        return ApiService.query('admin/customers-club')
    },
    getEventDetails(hashid) {
        return ApiService.query(`admin/customers-club/events/find/${hashid}`)
    },
}

export const allotmentService = {
    sync(hashid, params) {
        let form_data = convertToFormData(params)
        return ApiService.post(`allotment/sync/${hashid}`, params)
    },
    find(hashid) {
        return ApiService.get('allotment/find', hashid)
    },

    fetchUserShebas(params) {
        //console.log(params)
        return ApiService.post('allotment/fetch-user-shebas', params)
    },

    update(hashid, params) {
        return ApiService.post(`allotment/update/${hashid}`, params);
    },
    fetch(hashid) {
        return ApiService.get('allotment/fetch', hashid);
    },

    update_dedicated(hashid, params) {
        return ApiService.post(`allotment/update-dedicated/${hashid}`, params);
    },
    fetch_dedicated(hashid) {
        return ApiService.get('allotment/fetch-dedicated', hashid);
    },
}

export const blackListService = {
    addToSuspectedIPs(hashid) {
        return ApiService.post(`/blackList/addToSuspectedIPs/${hashid}`)
    },

    addToBlackIPs(hashid) {
        return ApiService.post(`/blackList/addToBlackIPs/${hashid}`)
    },

    fetchSuspectedIps() {
        return ApiService.query('/blackList/fetchSuspectedIPs')
    },

    fetchBlackIps() {
        return ApiService.query('/blackList/fetchBlackIPs')
    },

    deleteFromSuspectedIPs(hashid) {
        return ApiService.post(`/blackList/deleteFromSuspectedIPs/${hashid}`)
    },

    deleteFromBlackIPs(hashid) {
        return ApiService.post(`/blackList/deleteFromBlackIPs/${hashid}`)
    },
}

export const reportService = {
    fetchGatewaysStatistics(params) {
        let query = {
            query: params
        }
        return ApiService.post('reports/admin/gateways-Statistics', query)
    },

    fetchUsersStatistics(params) {
        let query = {
            query: params
        }
        return ApiService.post('reports/admin/users-Statistics', query)
    },

    fetchPfTerminalsStatistics(params) {
        let query = {
            query: params
        }
        return ApiService.post('reports/admin/pf-terminal-statistics', query)
    },

    getPfTerminalDetails(hashid){
        return ApiService.get('reports/admin/pf-terminal-statistics', hashid)
    },

    gatewayDetails(params, is_starshop = false) {
        const service = is_starshop ? StarShopApiService : ApiService;
        return service.post('reports/admin/gateway-details', params)
    },

    fetchTaxExports() {
        return ApiService.query(`reports/admin/get-tax-exports`)
    },

    fetchUserOfficialFactor(query) {
        return ApiService.query('reports/admin/get-user-official-factor', query)
    },

    userCoreAccountingInfo(param) {
        let hashid = {
            hashid: param
        }

        return ApiService.post('reports/admin/user-accounting-info', hashid);
    },

    userStarshopAccountingInfo(param) {
        let hashid = {
            hashid: param
        }

        return StarShopApiService.post('reports/admin/user-accounting-info', hashid);
    },

    userLoginInfo(param) {
        let hashid = {
            hashid: param
        }

        return ApiService.post('reports/admin/user-login-info', hashid);
    },

    fetchCoreTopUsers(query) {
        return ApiService.query('reports/admin/top-users-transactions-chart', query)
    },
    fetchCoreTopUsersAmountChart(query) {
        return ApiService.query('reports/admin/top-users-transactions-amount-chart', query)
    },
    fetchCoreTopUsersWageChart(query) {
        return ApiService.query('reports/admin/top-users-transactions-wage-chart', query)
    },

    fetchStarShopTopUsers() {
        return StarShopApiService.query('reports/admin/top-users-transactions-chart')
    }
}

export const posService = {

    getCustomerByCode(params) {
        return StarShopApiService.post('pos/get-customer-by-code', params)
    },

    fetch() {
        return StarShopApiService.query('pos/get-data')
    },

    addPosRequest(params) {
        let form_data = convertToPosFormData(params);
        return StarShopApiService.post('pos/add-pos-request', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },

    editPosRequest(params) {
        let form_data = convertToPosFormData(params);
        return StarShopApiService.post('pos/edit-pos-request', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },

    findStakeholder(hashid) {
        return StarShopApiService.get('pos/find-stakeholder', hashid)
    },

    addStakeholder(params) {
        let form_data = convertToPosFormData(params);
        return StarShopApiService.post('pos/add-stakeholder', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },
    addNewCustomer(params,psp) {
        return StarShopApiService.post('pos/'+psp.toLowerCase()+'/admin/novin/add-new-customer',params)
    },

    removeStakeholder(hashid) {
        return StarShopApiService.delete('pos/remove-stakeholder', hashid)
    },

    editStakeholder(params) {
        let form_data = convertToPosFormData(params);
        return StarShopApiService.post('pos/edit-stakeholder', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },

    uploadDocuments(params) {
        let form_data = convertToPosFormData(params);
        return StarShopApiService.post('pos/admin/upload-documents', form_data, {
            'Content-Type': 'multipart/form-data'
        })
    },

    sendDocumentsToPSP(shop_id) {
        return StarShopApiService.get('pos/admin/send-documents-to-psp',shop_id)
    },

    getPosRequestsCount() {
        return StarShopApiService.query('pos/admin/get-pos-requests-count')
    },

    getPosRequestDetails(hashid) {
        return StarShopApiService.get('pos/get-pos-request-detail',hashid)
    },
    changePosRequestStatus(params) {
        return StarShopApiService.post('pos/admin/change-pos-request-status',params)
    },

    removeDocument(params) {
        return StarShopApiService.post('pos/remove-document',params)
    },

    ibanInquiry(params) {
        return StarShopApiService.post('pos/iban-inquiry',params)
    },

    postalCodeInquiry(postal_code) {
        return StarShopApiService.get('pos/postal-code-inquiry',postal_code)
    },

    replaceSerialNumber(params) {
        return StarShopApiService.post('pos/replace-serial',params)
    },

    changeAddress(params) {
        return StarShopApiService.post('pos/change-address',params)
    },

    changeSheba(params) {
        return StarShopApiService.post('pos/change-sheba',params)
    },

    disableTerminal(shop_id) {
        return StarShopApiService.get('pos/disable-terminal',shop_id)
    },

    deleteTerminal(shop_id) {
        return StarShopApiService.get('pos/delete-terminal',shop_id)
    },
}
export const billService = {

    getCorporates(query) {
        return StarShopApiService.query('bill/admin/corporates', query)
    },

    addCorporate(params) {
        let form_data = convertToFormData(params)

        return StarShopApiService.post('bill/admin/add-corporate', form_data)
    },

    deleteCorporate(hashid) {
        return StarShopApiService.delete('bill/admin/delete-corporate', hashid)
    },

    findCorporate(hashid) {
        return StarShopApiService.get('bill/admin/find-corporate', hashid)
    },

    editCorporate(params) {
        let form_data = convertToFormData(params)

        return StarShopApiService.post('bill/admin/edit-corporate', form_data)
    },

    getGeneralSettings() {
        return StarShopApiService.query('bill/admin/general-settings')
    },

    getActiveCollectiveGateways() {
        return StarShopApiService.query('bill/admin/active-collective-gateways')
    },

    updateSettings(params) {
        return StarShopApiService.post('bill/admin/update-settings', params)
    },
}

export const cardToCardService = {
    adminFind(hashid) {
        return StarShopApiService.get('card-to-card/admin/gateway', hashid)
    },
    adminUpdateGatewayInfo(hashid, params) {
        return StarShopApiService.post('card-to-card/admin/gateway/'+ hashid, params)
    },
    adminUpdateWage(hashid, params) {
        return StarShopApiService.post('card-to-card/admin/change-gateway-wage/'+ hashid, params)
    },
    adminChangeGatewayStatus(hashid, params) {
        return StarShopApiService.post('card-to-card/admin/change-gateway-status/'+hashid, params)
    },
    adminUpdateGatewayLimits(hashid, params) {
        return StarShopApiService.post('card-to-card/admin/update-gateway-limits/'+ hashid, params)
    },
    adminUpdateGatewayCard(card_id, params) {
        return StarShopApiService.post('card-to-card/admin/update-bank-card/' + card_id, params)
    },
    find(hashid) {
        return StarShopApiService.get('card-to-card/common/gateway', hashid)
    },
    updateGatewayInfo(hashid, params) {
        return StarShopApiService.post('card-to-card/common/gateway/'+ hashid, params)
    },
    addBankCard(hashid, params) {
        return StarShopApiService.post('card-to-card/common/add-bank-card/'+ hashid, params)
    },
    updateBankCard(gateway_id,bank_card_id, params) {
        return StarShopApiService.post('card-to-card/common/edit-bank-card/'+ gateway_id+'/'+bank_card_id, params)
    },
    removeBankCard(gateway_id, card_id) {
        return StarShopApiService.delete('card-to-card/common/remove-bank-card/'+ gateway_id, card_id)
    },
    fetchSetting(gateway_id) {
        return StarShopApiService.get('card-to-card/common/settings', gateway_id)
    },
    updateSetting(params, gateway_id) {
        return StarShopApiService.post('card-to-card/common/settings/'+ gateway_id, params)
    },
    adminFetchSetting(gateway_id) {
        return StarShopApiService.get('card-to-card/admin/settings', gateway_id)
    },
    adminUpdateSetting(params, gateway_id) {
        return StarShopApiService.post('card-to-card/admin/settings/'+ gateway_id, params)
    },
}
export const cardToCardWalletService = {
    getSettings(has_acccess) {
        const route = has_acccess ? 'card-to-card/wallet/common/admin/settings' : 'card-to-card/wallet/common/settings'
        return StarShopApiService.query('card-to-card/wallet/common/settings')
    },

    updateWalletSettings(params) {
        let form_data = convertToFormData(params)
        return StarShopApiService.post('card-to-card/wallet/admin/update-settings', form_data)
    },

    rechargeWallet(params) {
        let form_data = convertToFormData(params)
        return StarShopApiService.post('card-to-card/wallet/common/recharge', form_data)
    },

    rechargeWalletManually(params) {
        let form_data = convertToFormData(params)
        return StarShopApiService.post('card-to-card/wallet/admin/recharge-manually', form_data)
    },
}

export const onlineContractService = {
    findTemplate(hashid) {
        return ApiService.get('online-contract/template', hashid)
    },
    addTemplate(params) {
        return ApiService.post('online-contract/template', params)
    },
    editTemplate(hashid, params) {
        return ApiService.post('online-contract/template/' + hashid, params)
    },
    removeTemplate(hashid) {
        return ApiService.delete('online-contract/template', hashid)
    },
    fetchGeneralWageSetting() {
        return ApiService.query('online-contract/setting/general-wage-setting')
    },
    updateGeneralWageSetting(params) {
        return ApiService.post('online-contract/setting/general-wage-setting' , params)
    },
    getLists() {
        return ApiService.get('online-contract/template/list' , [])
    },

    contractCreate(params) {
        return ApiService.post('online-contract/contract' , params)
    },
    findContract(hashid) {
        return ApiService.get('online-contract/contract', hashid)
    },

    contractUpdate(hashid,params) {
        return ApiService.post(`online-contract/contract/${hashid}` , params)
    },

    contractDelete(hashid) {
        return ApiService.delete(`online-contract/contract` , hashid)
    },
    getContractStatistics(params) {
        return ApiService.query('online-contract/contract/statistics', params)
    }
}

export const ipApi = {
    ipLocation() {
        return ApiService.query('ip')
    }
}

export const bankAccountsAccessTokenService = {
    adminStoreBankAccountsAccess(hashid, params) {
        return ApiService.update('admin/user/bank-account-access', hashid, params)
    }
}

export const starShopAccountingService = {
    getWalletBankAccountDeposits(hashid) {
        return StarShopApiService.post('accounting/admin/account/get-deposit', hashid)
    },
    createAccountTransaction(hashid, params) {
        return StarShopApiService.post('accounting/admin/transaction', hashid, params)
    },
    getAccountTransactions(params) {
        return StarShopApiService.get('accounting/admin/transactions', params)
    },
    getAccounts() {
        return StarShopApiService.query('accounting/admin/accounts')
    },
    createAccount(params) {
        return StarShopApiService.post('accounting/admin/account', params)
    },
    changeTransactionStatus(hashid, params) {
        return StarShopApiService.post('accounting/admin/transaction/change-status', hashid, params)
    },
    getTransaction(hashid) {
        return StarShopApiService.query(`accounting/admin/transactions?hashid=${hashid}`)
    },
    createExcelRequest(hashid, params) {
        return StarShopApiService.post('accounting/admin/excel-request', hashid, params)
    },
    removeAccount(hashid) {
        return StarShopApiService.post(`accounting/admin/delete-account?hashid=${hashid}`)
    },
    getAllAccounts() {
        return StarShopApiService.query('accounting/admin/all-accounts')
    },
    calculateDiscrepancies(hashid) {
        return StarShopApiService.post(`accounting/admin/transactions/calculate-discrepancies?hashid=${hashid}`)
    },
    updateDiscrepancyStatus(hashid, params) {
        return StarShopApiService.post('accounting/admin/discrepancy/change-status', hashid, params)
    },
    
    getHolidays() {
        return StarShopApiService.get('accounting/admin/holidays');
    },

    createHoliday(data) {
        return StarShopApiService.post('accounting/admin/holidays', data);
    },

    updateHoliday(hashid, data) {
        return StarShopApiService.put(`accounting/admin/holidays/${hashid}`, data);
    },

    addToTransactions(params) {
        return StarShopApiService.post('accounting/admin/discrepancy/add-to-transaction', params)
    },

    deleteHoliday(hashid) {
        return StarShopApiService.delete(`/accounting/admin/holidays/${hashid}`);
    }
}

export const accountingService = {
    getWalletBankAccountDeposits(hashid) {
        return ApiService.post('accounting/admin/account/get-deposit', hashid)
    },
    createAccountTransaction(hashid, params) {
        return ApiService.post('accounting/admin/transaction', hashid, params)
    },
    getAccountTransactions(params) {
        return ApiService.get('accounting/admin/transactions', params)
    },
    getAccounts() {
        return ApiService.query('accounting/admin/accounts')
    },
    createAccount(params) {
        return ApiService.post('accounting/admin/account', params)
    },
    changeTransactionStatus(hashid, params) {
        return ApiService.post('accounting/admin/transaction/change-status', hashid, params)
    },
    getTransaction(hashid) {
        return ApiService.query(`accounting/admin/transactions?hashid=${hashid}`)
    },
    createExcelRequest(hashid, params) {
        return ApiService.post('accounting/admin/excel-request', hashid, params)
    },
    removeAccount(hashid) {
        return ApiService.post(`accounting/admin/delete-account?hashid=${hashid}`)
    },
    getAllAccounts() {
        return ApiService.query('accounting/admin/all-accounts')
    },
    getAllAccountsOfOneBankForSelect() {
        return ApiService.query('accounting/admin/get-all-accounts-for-select/')
    },
    calculateDiscrepancies(hashid) {
        return ApiService.post(`accounting/admin/transactions/calculate-discrepancies?hashid=${hashid}`)
    },
    updateDiscrepancyStatus(hashid, params) {
        return ApiService.post('accounting/admin/discrepancy/change-status', hashid, params)
    },

    getHolidays() {
        return ApiService.get('accounting/admin/holidays');
    },

    createHoliday(data) {
        return ApiService.post('accounting/admin/holidays', data);
    },

    updateHoliday(hashid, data) {
        return ApiService.put(`accounting/admin/holidays/${hashid}`, data);
    },

    addToTransactions(params) {
        return ApiService.post('accounting/admin/discrepancy/add-to-transaction', params)
    },

    deleteHoliday(hashid) {
        return ApiService.delete(`/accounting/admin/holidays/${hashid}`);
    }
}
